import React, { useEffect, useState } from 'react'
import { Dialog, DialogActions, DialogContent, DialogTitle, IconButton, LinearProgress, Tooltip } from "@mui/material";
import { Formik, Form } from 'formik'
import * as Yup from 'yup'

import { Add, Edit } from '@mui/icons-material';

import FormikControl from '../../../../../../components/FormikControl/FormikControl';
import { useAlert } from '../../../../../../context/AlertContext';
import partyAddressServices from '../partyAddressServices';
import { useAppData } from '../../../../../../context/AppDataContext';



function PartyAddressForm({partyId,data,callback,defaultOpen=false }) {

    const {AppAlert} = useAlert();
    const {masters} = useAppData();
    const [formValues, setFormValues] = useState(null);
    const [dialogStatus, setDialogStatus] = useState(false);
    const [savingInProgress, setSavingStatus] = useState(false);
    const [differentSupplyState,setDifferentSupplyState] = useState(false);

    const initialValues = {
        partyId:partyId,
        contactPerson:"",
        city:"",
        state:"",
        address:"",
        zip:"",
        phone:"",
        email:"",

        supplyState:"",
    }

    const updateData = ()=>{
        let autoFill = {
            id:data.id,
            partyId:data.partyId,
            contactPerson:data.contactPerson,
            city:data.city,
            state:data.state,
            address:data.address,
            zip:data.zip,
            phone:data.phone,
            email:data.email,
            supplyState:data.supplyState,
        }

        if(data.supplyState !== data.state){
            setDifferentSupplyState(true);
        }
        setFormValues(autoFill);
        setDialogStatus(true)
    }

    const validationRule = Yup.object({
        city:Yup.string().required("Required"),
        state:Yup.string().required("Required"),
        //address:Yup.string().required("Required"),
        //zip:Yup.string().required("Required"),
        phone:Yup.string().matches(/^[0-9]+$/, "Phone number must contain only digits").length(10, "Phone number must be exactly 10 digits").required("Required"),
    });

    const addNew = ()=>{
        setFormValues(initialValues);
        setDialogStatus(true)
    }

    const handleClose  = () =>{
        setDialogStatus(false);
    }

    const onSubmit = (values, onSubmitProps) => {

        if(values.supplyState == "" || values.supplyState == 0){
            values.supplyState = values.state;
        }

        partyAddressServices.save(values).then(res=>{
            AppAlert(res.msg);
            setDialogStatus(false);
            callback();
        }).catch(error=>{
            AppAlert(error.msg,"error");
        }).finally(()=>{
            setSavingStatus(false);
        })
    }

    useEffect(()=>{
        if(defaultOpen){
            setTimeout(addNew,100)
        }
    },[defaultOpen])

    return (
        <>
            {!data &&
                <Tooltip title="Add New">
                    <button type="button" className="btn btn-primary" onClick={addNew} ><Add/> Add New Address</button>
                </Tooltip>
            }
            {data &&
                <Tooltip title="Update">
                    {/*<button type="button" className="btn btn-outline-primary" onClick={updateData} ><Edit/> Address</button> */}
                    <IconButton className='ms-2' onClick={updateData} style={{padding:"0px"}}>
                        <Edit/>
                    </IconButton>
                </Tooltip>
            }
            <Dialog
                open={dialogStatus}
                keepMounted
                onClose={handleClose}
                fullWidth={true}
                maxWidth="md"
                aria-describedby="alert-dialog-slide-description"
            >

                <Formik
                    initialValues={formValues || initialValues}
                    validationSchema={validationRule}
                    onSubmit={onSubmit}
                    enableReinitialize validateOnMount
                >
                    {
                        (formik) => {
                            //console.log(formik.values);
                            return (
                                <Form>
                                    <DialogTitle>Party Address Form</DialogTitle>
                                    <DialogContent>
                                            <div className="row p-3">

                                                
                                                <div className="col-md-6 my-2" >
                                                    {dialogStatus &&
                                                    <FormikControl control="input" autoFocus formik={formik} type="text"
                                                        label="Contact Person (To Display On Shipping Label)" name="contactPerson" 
                                                    />
                                                    }
                                                </div>

                                                <div className="col-md-6 my-2" >
                                                    <FormikControl control="input" formik={formik} type="text" 
                                                        label="Phone" name="phone" 
                                                    />
                                                </div>
                                                <div className="col-md-6 my-2" >
                                                    <FormikControl control="input" formik={formik} type="text"
                                                        label="Email" name="email"   
                                                    />
                                                </div>

                                                <hr className='my-3' />
                                                <div className="col-md-4 my-2" >
                                                    <FormikControl control="input" formik={formik} type="text"
                                                        label="City" name="city"   
                                                    />
                                                </div>

                                                <div className='col-md-4 my-2'>
                                                    <FormikControl control="autoselect" formik={formik} 
                                                        label="State" name="state"  
                                                        options={masters['indian-state']} multiple={false} 
                                                    />
                                                </div>

                                                <div className="col-md-4 my-2" >
                                                    <FormikControl control="input" formik={formik} type="text"
                                                        label="Pincode" name="zip"   
                                                    />
                                                </div>

                                                <div className="col-md-12 my-2" >
                                                    <FormikControl control="input" formik={formik} type="text" multiline={true}
                                                        label="Address" name="address"   
                                                    />
                                                </div>
 


                                                {differentSupplyState ?
                                                    <div className="col-md-12 my-2 mt-3" >
                                                        <FormikControl control="autoselect" formik={formik} 
                                                            label="Supply To" name="supplyState"  
                                                            options={masters['indian-state']} multiple={false} 
                                                        />
                                                    </div>
                                                    :
                                                    <button type="button" className='btn btn-primary mt-3' onClick={()=> setDifferentSupplyState(true) } >Use Dufferent State for Supply</button>
                                                }

                                            </div>
                                           
                                        <div className="row mt-3">
                                            <div className='col-md-12'>
                                                {savingInProgress ?
                                                    <LinearProgress/>
                                                    :
                                                    <>
                                                        <button className="btn btn-primary float-end" type="submit">Save</button>
                                                        <button className="btn btn-outline-primary" type="button" onClick={handleClose}>Cancel</button>
                                                    </>
                                                }
                                            </div>
                                            <div className='col-md-12'>
                                                { /* JSON.stringify(formik.values)  */ }
                                            </div>
                                        </div>
                                    </DialogContent>
                                </Form>
                            )
                        }
                    }
                </Formik>
            </Dialog>

        </>
    )
}

export default PartyAddressForm